const LeftCreditTable = ({
    header = [],
    creditLeft = [],
    hasData,
    loading = false,
    error = null
}) => {
    return (
        <div className="table-credit-left-responsive">
            <table className="table-credit-left">
                <thead>
                    <tr>
                        {header.map((headers, index) => (
                            <th key={index}>{headers}</th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {/* Loading */}
                    {loading && (
                        <tr>
                            <td colSpan={header.length} className="no-data">
                                Loading...
                            </td>
                        </tr>
                    )}

                    {/* Error */}
                    {!loading && error && (
                        <tr>
                            <td
                                colSpan={header.length}
                                className="no-data text-red-500"
                            >
                                {error}
                            </td>
                        </tr>
                    )}

                    {/* Data */}
                    {!loading && !error && hasData && (
                        creditLeft.map((info, index) => (
                            <tr key={index}>
                                <td>{info.TotalCredit}</td>
                                <td>{info.AmountPaid}</td>
                                <td>{info.amountleft}</td>
                                <td>{info.guest}</td>
                                <td>{info.guestAddress}</td>
                                <td>{info.guestEmail}</td>
                                <td>{info.guestID}</td>
                                <td>{info.guestPhone}</td>
                            </tr>
                        ))
                    )}

                    {/* Empty */}
                    {!loading && !error && !hasData && (
                        <tr>
                            <td colSpan={header.length} className="no-data">
                                No data available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default LeftCreditTable
